import gql from 'graphql-tag';

export const CALENDAR_VIEWABLE_USERS = gql`
  query CalendarViewConfiguration {
    dealActivity {
      result: calendarViewableUsers {
        error
        success
        list {
          value: id
          label: fullName
        }
      }
    }
  }
`;
